module.exports = __webpack_public_path__ + "img/artificialtechnology_img.c7561e84.png";